<template>
  <div style="padding: 20px">
    <el-form
      ref="ruleForm"
      label-width="130px"
      class="demo-ruleForm"
      :rules="rules"
      :model="ruleForm"
    >
      <el-form-item label="综合折减(%)" prop="flowLoss">
        <el-input v-model.number="ruleForm.flowLoss" :maxlength="10"></el-input>
      </el-form-item>
      <el-form-item label="尾流折减(%)" prop="synthesizeLoss">
        <el-input
          v-model.number="ruleForm.synthesizeLoss"
          :maxlength="10"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="save" type="primary">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ruleForm: {
        flowLoss: '',
        synthesizeLoss: ''
      },
      rules: {
        flowLoss: [
          { required: true, message: '请输入综合折减', trigger: 'blur' },
          { type: 'number', message: '只能输入数字', trigger: 'blur' }
        ],
        synthesizeLoss: [
          { required: true, message: '请输入尾流折减', trigger: 'blur' },
          { type: 'number', message: '只能输入数字', trigger: 'blur' }
        ]
      }
    };
  },
  async mounted() {
    await this.getEnergyDefaultParam();
  },
  methods: {
    async getEnergyDefaultParam() {
      const { data } = await this.$fetch(
        '/manage/station/getEnergyDefaultParam',
        {
          module: 'manage'
        }
      );
      const { flowLoss, synthesizeLoss } = data.defaultParam[0];
      this.ruleForm.flowLoss = flowLoss;
      this.ruleForm.synthesizeLoss = synthesizeLoss;
    },
    async save() {
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          await this.$postForm({
            url: '/manage/station/saveEnergyDefaultParam',
            module: 'manage',
            data: {
              flowLoss: this.ruleForm.flowLoss,
              synthesizeLoss: this.ruleForm.synthesizeLoss
            },
            showLoading: true,
            showError: true,
            showSuccess: true
          });
          await this.getEnergyDefaultParam();
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-input__inner {
  width: 200px;
}
</style>
